export default __webpack_public_path__ + "static/media/team-4.fa1b8321.jpg";